@if (bleedingAndSuppurationSymbolSrc()) {
  <div class="absolute w-full" [ngClass]="[bleedingAndSuppurationSymbolAlignClass()]" @fadeInOnly>
    <img class="mx-auto" [ngClass]="[bleedingAndSuppurationSymbolSizeClass()]" [src]="bleedingAndSuppurationSymbolSrc()" />
  </div>
}

<div class="grid" [ngClass]="[pocketDepthSymbolSizeClass(), pocketDepthSymbolAlignClass()]">
  <img class="col-start-1 row-start-1" [ngClass]="pocketDepthSymbolRotation()" [src]="pocketDepthSymbolSrc()" />
  @if ((isQuadrantSelected() && probingSite()?.pocketDepth) || (!isQuadrantSelected() && (probingSite()?.pocketDepth ?? 0) > 1)) {
    <h6 class="z-10 col-start-1 row-start-1 text-center text-text-white" [ngClass]="pocketDepthTextClass()" @fadeInOnly>
      {{ probingSite()?.pocketDepth }}
    </h6>
  }
</div>
